const REFERRER_KEY = 'aiq_referrer'
const REFERRER_TIMESTAMP_KEY = 'aiq_referrer_ts'
const REFERRER_TTL_MS = 30 * 24 * 60 * 60 * 1000 // 30 days

export function initReferrer() {
  const params = new URLSearchParams(window.location.search)
  const ref = params.get('ref') || params.get('referrer')
  if (ref) {
    localStorage.setItem(REFERRER_KEY, ref)
    localStorage.setItem(REFERRER_TIMESTAMP_KEY, String(Date.now()))
  }
}

export function getReferrer(): string | null {
  const ts = localStorage.getItem(REFERRER_TIMESTAMP_KEY)
  if (ts && Date.now() - Number(ts) > REFERRER_TTL_MS) {
    localStorage.removeItem(REFERRER_KEY)
    localStorage.removeItem(REFERRER_TIMESTAMP_KEY)
    return null
  }
  return localStorage.getItem(REFERRER_KEY)
}
